<template>
  <div>
    <!-- LOADING -->
    <!-- <div
      v-if="busy"
      class="d-flex flex-column align-items-center mt-8 py-6"
    >
      <spring-spinner
        :animation-duration="1500"
        :size="60"
        color="#bf0000"
        class="mx-auto"
      />
      <p class="primary--text mx-auto font-weight-bold mt-6">
        در حال بارگذاری...
      </p>
    </div> -->
    <div>
      <pie-header :role="role" :allPies="allPies" />

      <v-card>
        <div>
          <div class="mt-1 pb-8" id="time-range">
            <v-row>
              <v-col sm="6" cols="12">
                <label class="dark-text fs-small font-weight-bold"
                  >بازه زمانی</label
                >
                <!-- <span id="theDate2">
                    <v-text-field
                      outlined
                      dense
                      class="mt-2"
                      v-model="fund.date"
                      prepend-inner-icon="mdi-calendar-month"
                    ></v-text-field
                  ></span>
                  <date-picker
                    element="theDate2"
                    v-model="fund.date"
                    color="#bf0000"
                  ></date-picker> -->
                <MyCalendar
                  @submit="getContributionsData()"
                  @getStartDate="getStartDate"
                  @getEndDate="getEndDate"
                  class="mt-2 mb-4"
                />
              </v-col>
              <v-col sm="6" cols="12" class="text-sm-left text-right">
                <v-btn
                  @click="$refs.activeTable.$el.click()"
                  class="pa-5 border flex-row mb-7 green--text text--darken-2"
                  depressed
                  :disabled="!computedList.length"
                >
                  <v-icon class="me-1" color="green darken-2"
                    >mdi-file-excel-outline</v-icon
                  >
                  خروجی اکسل
                </v-btn>
                <vue-excel-xlsx
                  v-show="false"
                  ref="activeTable"
                  :data="computedList"
                  :columns="excelFields"
                  :file-name="`مشارکت‌های فعال_${currentDate}`"
                  :sheet-name="'مشارکت‌های فعال'"
                >
                  دریافت اکسل
                </vue-excel-xlsx>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="3" cols="12">
                <v-select
                  class="mb-5"
                  hide-details
                  outlined
                  dense
                  :items="options"
                  placeholder="مرتب‌سازی بر اساس"
                  v-model="sortBy"
                  @change="getContributionsData"
                >
                  <template v-slot:append>
                    <v-icon
                      color="red"
                      v-if="sortBy"
                      @click="sortBy = ''"
                      @mouseup.stop
                      @click.prevent.stop="sortBy = ''"
                      >mdi-close</v-icon
                    >
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row class="mb-3 px-3">
              <v-col cols="12" sm="6" md="4" class="mb-5">
                <div class="fs-xlarge pb-3">نوع مشارکت</div>
                <div
                  v-for="(item, index) in contributionTypes"
                  :key="index"
                  class="mt-1"
                >
                  <v-checkbox
                    v-model="typeFilter"
                    :label="item.type_fa + ' (' + item.number + ')'"
                    color="red"
                    :value="item.type"
                    hide-details
                  ></v-checkbox>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="mb-5">
                <div class="fs-xlarge pb-3">اعضای تیم</div>
                <div v-for="(item, index) in members" :key="index" class="mt-1">
                  <v-checkbox
                    v-model="memberFilter"
                    :label="item.userName"
                    color="red"
                    :value="item.id"
                    hide-details
                  ></v-checkbox>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="mb-5">
                <div class="fs-xlarge pb-3">پروژه‌ها</div>
                <div
                  v-for="(item, index) in projects"
                  :key="index"
                  class="mt-1"
                >
                  <v-checkbox
                    v-model="projectFilter"
                    :label="item.project"
                    color="red"
                    :value="item.project"
                    hide-details
                  ></v-checkbox>
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- TABLE -->
          <template>
            <div class="custom-table">
              <v-data-table
                :mobile-breakpoint="0"
                :headers="activeHeaders"
                :items="computedList"
                :page.sync="CurrentPage"
                :items-per-page="PerPage"
                :hide-default-footer="true"
                item-key="id"
                show-expand
                :expanded.sync="expanded"
                :loading="tableLoading"
                loading-text="در حال بارگذاری اطلاعات..."
              >
                <template slot="no-data">
                  <div class="font-weight-bold">
                    موردی برای نمایش وجود ندارد!
                  </div>
                </template>
                <!-- EXPANDED-ROW -->
                <template
                  v-slot:[`item.data-table-expand`]="{ item, isExpanded }"
                >
                  <span
                    v-if="item.type == 'well'"
                    class="pointer"
                    @click="handleExpansion(item, isExpanded)"
                  >
                    <v-icon>mdi-plus-thick</v-icon>
                  </span>
                </template>
                <template v-slot:[`expanded-item`]="{ headers, item }">
                  <td class="box" :colspan="headers.length">
                    <v-row
                      v-for="(item2, index) in item.data"
                      :key="index"
                      class="mr-15 mt-5 mb-5"
                    >
                      <v-col cols="2">
                        <div class="font-weight-bold" style="text-align: right">
                          نام:
                          <span class="font-weight-regular">{{
                            item2.name
                          }}</span>
                        </div>
                      </v-col>
                      <v-col cols="2">
                        <div class="font-weight-bold" style="text-align: right">
                          مقدار:
                          <span class="font-weight-regular">{{
                            item2.amount
                          }}</span>
                        </div>
                      </v-col>
                      <v-col cols="2">
                        <div class="font-weight-bold" style="text-align: right">
                          سهم‌ها:
                          <span class="font-weight-regular">{{
                            item2.slices
                          }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </td>
                </template>
                <!-- ACTIONS -->
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn class="primary" @click="openEditDialog(item)">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <!-- username column -->
                <template v-slot:[`item.userName`]="{ item }">
                  <span
                    class="font-weight-bold"
                    :style="'color:' + item.color"
                    >{{ item.userName }}</span
                  >
                </template>
                <!-- hours spent column -->
                <template v-slot:[`item.hoursSpent`]="{ item }">
                  <span>{{
                    item.hoursSpent != "-" ? item.hoursSpent + " ساعت" : "-"
                  }}</span>
                </template>
                <!-- activity column -->
                <template v-slot:[`item.activity`]="{ item }">
                  <span>{{ item.activity ? item.activity : "-" }}</span>
                </template>
                <!-- slices column -->
                <template v-slot:[`item.slices`]="{ item }">
                  <span>{{ Number(item.slices).toLocaleString() }}</span>
                </template>
                <!-- description column -->
                <template v-slot:[`item.description`]="{ item }">
                  <v-btn class="primary" @click="openDescDialog(item)">
                    <v-icon>mdi-comment-text-outline</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
              <v-pagination
                v-model="CurrentPage"
                :length="Math.ceil(computedList.length / PerPage)"
                :total-visible="5"
                prev-icon="mdi-arrow-left"
                next-icon="mdi-arrow-right"
                class="mt-8"
              ></v-pagination>
            </div>
          </template>
        </div>

        <!-- EDIT-DIALOG -->
        <v-dialog v-model="EditDialog" v-if="EditDialog" width="700">
          <v-card>
            <v-card-title class="pa-2" cols="12">
              <!-- <v-row>
                <v-col>
                  <v-icon class="float-end">mdi-information-outline</v-icon>
                </v-col>
              </v-row> -->
            </v-card-title>
            <v-card-text class="pa-2s">
              <v-alert outlined type="warning" border="left"
                >ویرایش مشارکت {{ selected.userName }}</v-alert
              >

              <label class="dark-text fs-small font-weight-bold"
                ><span class="primary--text">*</span> تاریخ مشارکت</label
              >
              <span id="editDate">
                <v-text-field
                  outlined
                  dense
                  class="mt-2"
                  v-model="selected.dateCont"
                  prepend-inner-icon="mdi-calendar-month"
                ></v-text-field
              ></span>
              <date-picker
                element="editDate"
                v-model="selected.dateCont"
                color="#bf0000"
              ></date-picker>

              <label class="dark-text fs-small font-weight-bold">توضیحات</label>
              <v-textarea
                outlined
                dense
                class="mt-2"
                rows="3"
                v-model="selected.description"
              ></v-textarea>

              <p class="primary--text font-weight-bold">
                <v-icon class="primary--text">mdi-alert-circle-outline</v-icon>
                تعیین دوره زمانی در این نسخه بی تاثیر خواهد بود.
              </p>

              <label class="dark-text fs-small font-weight-bold"
                ><span class="primary--text">*</span> تکرار مشارکت</label
              >
              <v-radio-group
                v-model="selected.repeatCont"
                style="transform: translateX(18px)"
                row
                class="mt-3"
                @change="setRepeatTime"
              >
                <v-radio
                  v-for="(item, index) in repeatOptions"
                  :key="index"
                  :label="item.text"
                  :value="item.value"
                ></v-radio>
              </v-radio-group>

              <div v-if="selected.repeatCont != 'off'">
                <label class="dark-text fs-small font-weight-bold"
                  ><span class="primary--text">*</span> تاریخ شروع تکرار</label
                >
                <span id="theDate2">
                  <v-text-field
                    outlined
                    dense
                    class="mt-2"
                    v-model="selected.repeatDate"
                    prepend-inner-icon="mdi-calendar-month"
                  ></v-text-field>
                </span>
                <date-picker
                  element="theDate2"
                  v-model="selected.repeatDate"
                  color="#bf0000"
                ></date-picker>
              </div>

              <div
                class="d-flex flex-sm-row flex-column justify-space-between mt-4"
              >
                <v-btn
                  width="160"
                  class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
                  @click="doEdit()"
                  :loading="busy"
                  ><v-icon small class="me-1">mdi-check</v-icon> ذخیره‌سازی
                  تغییرات</v-btn
                >
                <v-btn
                  width="160"
                  @click="EditDialog = false"
                  class="primary white--text mx-sm-0 mx-auto"
                  ><v-icon small class="me-1">mdi-close</v-icon> لغو</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- PENDING-EDIT-DIALOG -->
        <v-dialog v-model="PendingDialog" v-if="PendingDialog" width="700">
          <v-card>
            <v-card-title class="pa-2" cols="12">
              <v-row>
                <v-col cols="6">
                  <span class="fs-xlarge px-3">تایید مشارکت</span>
                </v-col>
                <!-- <v-col cols="6">
                  <v-icon class="float-end">mdi-information-outline</v-icon>
                </v-col> -->
              </v-row>
            </v-card-title>
            <v-card-text class="pa-2 pt-6">
              <div class="fs-large">
                آیا از تایید از این مشارکت اطمینان دارید؟
              </div>
              <br />
              <!-- <label class="dark-text fs-small font-weight-bold"
                >توضیحات (تا 200 کاراکتر)</label
              >
              <v-textarea
                outlined
                dense
                class="mt-2"
                rows="3"
                v-model="fund.description"
              ></v-textarea> -->
              <div
                class="d-flex flex-sm-row flex-column justify-space-between mt-4"
              >
                <v-btn
                  width="150"
                  class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
                  @click="approveContribution()"
                  :loading="busy"
                  ><v-icon small class="me-1">mdi-check</v-icon> تایید
                  مشارکت</v-btn
                >
                <v-btn
                  width="150"
                  @click="PendingDialog = false"
                  class="primary white--text mx-sm-0 mx-auto"
                  ><v-icon small class="me-1">mdi-close</v-icon> بستن</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- PENDING-REMOVE-DIALOG -->
        <v-dialog
          v-model="PendingRemoveDialog"
          v-if="PendingRemoveDialog"
          width="700"
        >
          <v-card>
            <v-card-title class="pa-2" cols="12">
              <span class="fs-xlarge">رد مشارکت</span>
            </v-card-title>
            <v-card-text class="pa-2">
              <div class="fs-large">آیا میخواهید این مشارکت را رد کنید؟</div>
              <br />

              <div
                class="d-flex flex-sm-row flex-column justify-space-between mt-4"
              >
                <v-btn
                  width="150"
                  class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
                  @click="rejectContribution()"
                  :loading="busy"
                  ><v-icon small class="me-1">mdi-check</v-icon> رد
                  مشارکت</v-btn
                >
                <v-btn
                  width="150"
                  @click="PendingRemoveDialog = false"
                  class="primary white--text mx-sm-0 mx-auto"
                  ><v-icon small class="me-1">mdi-close</v-icon> بستن</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- REMOVE-DIALOG -->
        <v-dialog v-model="RemoveDialog" v-if="RemoveDialog" width="700">
          <v-card>
            <v-card-title class="pa-2" cols="12">
              <span class="fs-xlarge">حذف مشارکت</span>
            </v-card-title>
            <v-card-text class="pa-2 pt-6">
              <div class="fs-large">آیا میخواهید این مشارکت را حذف کنید؟</div>
              <br />
              <label class="dark-text fs-small font-weight-bold"
                >توضیحات (تا 200 کاراکتر)</label
              >
              <v-textarea
                outlined
                dense
                class="mt-2"
                rows="3"
                v-model="fund.description"
              ></v-textarea>
              <div
                class="d-flex flex-sm-row flex-column justify-space-between mt-4"
              >
                <v-btn
                  width="150"
                  class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
                  @click="submit()"
                  :loading="busy"
                  ><v-icon small class="me-1">mdi-check</v-icon> حذف</v-btn
                >
                <v-btn
                  width="150"
                  @click="RemoveDialog = false"
                  class="primary white--text mx-sm-0 mx-auto"
                  ><v-icon small class="me-1">mdi-close</v-icon> لغو</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- DESC-DIALOG -->
        <v-dialog v-model="DescDialog" v-if="DescDialog" width="700">
          <v-card>
            <v-card-title class="pa-2" cols="12">
              <span class="fs-xlarge">توضیحات مشارکت</span>
            </v-card-title>
            <v-card-text class="pa-2 pt-4">
              <!-- <v-textarea
                outlined
                dense
                class="mt-2"
                rows="3"
                v-model="fund.description"
              ></v-textarea> -->
              <p
                class="font-weight-bold"
                :class="!selectedDesc.description ? 'red--text' : ''"
              >
                {{
                  selectedDesc.description != ""
                    ? selectedDesc.description
                    : "توضیحاتی به ثبت نرسیده است!"
                }}
              </p>
              <div class="text-left">
                <v-btn
                  width="150"
                  @click="DescDialog = false"
                  class="primary white--text mx-sm-0 mx-auto"
                >
                  فهمیدم!</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- STOP-DIALOG -->
        <v-dialog v-model="StopDialog" v-if="StopDialog" width="700">
          <v-card>
            <v-card-title class="pa-2" cols="12">
              <span class="fs-xlarge">متوقف کردن تکرار مشارکت</span>
            </v-card-title>
            <v-card-text class="pa-2 pt-6">
              <div class="fs-large">آیا میخواهید این مشارکت را حذف کنید؟</div>
              <br />
              <div
                class="d-flex flex-sm-row flex-column justify-space-between mt-4"
              >
                <v-btn
                  width="150"
                  class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
                  @click="submit()"
                  :loading="busy"
                  ><v-icon small class="me-1">mdi-check</v-icon> حذف</v-btn
                >
                <v-btn
                  width="150"
                  @click="StopDialog = false"
                  class="primary white--text mx-sm-0 mx-auto"
                  ><v-icon small class="me-1">mdi-close</v-icon> لغو</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali";
import utilities from "./../../mixins/utilities";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { SpringSpinner } from "epic-spinners";
import MyCalendar from "../../components/MyCalendar.vue";
const PieHeader = () => import("@/components/PieHeader");
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    SpringSpinner,
    MyCalendar,
    PieHeader,
  },
  mixins: [utilities],
  data() {
    return {
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      role: "",
      sortBy: "",
      expanded: [],
      tab: null,
      busy: false,
      startDate: "",
      endDate: "",
      filter: "",
      allPies: [],
      typeFilter: [],
      memberFilter: [],
      projectFilter: [],
      contributionTypes: [],
      members: [],
      projects: [],
      tableLoading: false,
      EditDialog: false,
      RemoveDialog: false,
      PendingRemoveDialog: false,
      DescDialog: false,
      StopDialog: false,
      showFilter: false,
      PendingDialog: false,
      CurrentPage: 1,
      PerPage: 10,
      totalRows: 2,
      repeatCont: "off",
      selected: {},
      selectedDesc: {},
      repeatOptions: [
        {
          text: "بدون تکرار",
          value: "off",
        },
        {
          text: "روزانه",
          value: "daily",
        },
        {
          text: "هفتگی",
          value: "weekly",
        },
        {
          text: "هر دو هفته یکبار",
          value: "biweekly",
        },
        {
          text: "ماهانه",
          value: "monthly",
        },
        {
          text: "سالانه",
          value: "annually",
        },
      ],
      newItem: {
        dateCont: moment(new Date()).format("jYYYY/jMM/jDD"),
        repeatCont: "off",
        amount: 0,
        receiveCont: 0,
        description: "",
      },
      datePicker: VuePersianDatetimePicker,
      payment: {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        description: "",
        amount: "",
      },
      fund: {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        description: "",
        amount: "",
        fundUserId: "",
        finderId: "",
      },
      drawFundData: {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        description: "",
        amount: "",
      },
      items: [],
      text: "",
      options: [
        {
          text: "تاریخ مشارکت",
          value: "dateCont",
        },
        {
          text: "اخیرا اضافه‌‌شده",
          value: "date",
        },
      ],
      sortBy: "",
      activeHeaders: [
        {
          text: "اعضای تیم",
          align: "start",
          sortable: false,
          value: "userName",
        },
        { text: "نام ثبت‌ کننده", sortable: false, value: "managerName" },
        { text: "مشارکت‌ها", sortable: false, value: "type_fa" },
        { text: "وضعیت", sortable: false, value: "status_fa" },
        { text: "پروژه‌ها", sortable: false, value: "activity" },
        { text: "زمان سپری‌‌شده", sortable: false, value: "hoursSpent" },
        { text: "زمان ثبت", sortable: false, value: "date" },
        { text: "توضیحات", sortable: false, value: "description" },
        { text: "سهم‌ها", value: "slices" },
        { text: "عملیات", sortable: false, value: "actions" },
      ],
      excelFields: [
        {
          label: "اعضای تیم",
          field: "userName",
        },
        { label: "نام ثبت‌ کننده", field: "managerName" },
        { label: "مشارکت‌ها", field: "type_fa" },
        { label: "وضعیت", field: "status_fa" },
        { label: "پروژه‌ها", field: "activity" },
        { label: "زمان سپری‌‌شده", field: "hoursSpent" },
        { label: "زمان ثبت", field: "date" },
        { label: "سهم‌ها", field: "slices" },
      ],
    };
  },
  methods: {
    handleExpansion(item, state) {
      const itemIndex = this.expanded.indexOf(item);

      state ? this.expanded.splice(itemIndex, 1) : this.expanded.push(item);
    },
    goToPie(item) {
      this.$router.push("/home/" + item.id);
      localStorage.setItem("selectedPie", item.id);
      localStorage.setItem("role", item.userRole);
      localStorage.setItem("restriction", item.restriction);
      localStorage.setItem("ownerId", item.pieUserId);
    },
    openEditDialog(item) {
      this.selected = JSON.parse(JSON.stringify(item));
      this.selected.dateCont = this.selected.dateCont.split(" - ")[1];
      this.EditDialog = true;
    },
    openRemoveDialog() {
      this.RemoveDialog = true;
    },
    openDescDialog(item) {
      this.selectedDesc = item;
      this.DescDialog = true;
    },
    openStopDialog() {
      this.StopDialog = true;
    },
    getStartDate(value) {
      this.startDate = value;
    },
    getEndDate(value) {
      this.endDate = value;
    },
    setRepeatTime() {
      if (this.selected.repeatCont == "daily") {
        this.selected.repeatDate = moment(new Date())
          .add(1, "days")
          .format("jYYYY/jMM/jDD");
      } else if (this.selected.repeatCont == "weekly") {
        this.selected.repeatDate = moment(new Date())
          .add(7, "days")
          .format("jYYYY/jMM/jDD");
      } else if (this.selected.repeatCont == "biweekly") {
        this.selected.repeatDate = moment(new Date())
          .add(14, "days")
          .format("jYYYY/jMM/jDD");
      } else if (this.selected.repeatCont == "monthly") {
        this.selected.repeatDate = moment(new Date())
          .add(30, "days")
          .format("jYYYY/jMM/jDD");
      } else if (this.selected.repeatCont == "annually") {
        this.selected.repeatDate = moment(new Date())
          .add(365, "days")
          .format("jYYYY/jMM/jDD");
      }
    },
    showFilters() {
      this.showFilter = !this.showFilter;
    },
    openPendingEditDialog(item) {
      this.selected = item;
      this.PendingDialog = true;
    },
    openPendingRemoveDialog(item) {
      this.selected = item;
      this.PendingRemoveDialog = true;
    },

    getContributionsData() {
      this.tableLoading = true;
      this.$http
        .post(
          this.baseUrl +
            "/" +
            this.role +
            "/pie/allContributions/" +
            this.$route.params.id,
          {
            startDate: this.startDate,
            endDate: this.endDate,
            contributions: this.typeFilter,
            projects: this.projectFilter,
            users: this.memberFilter,
            sort: this.sortBy == "dateCont" ? "dateCont" : undefined,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.contributionTypes = res.data.contributionTypes;
            this.members = res.data.pieUsers;
            this.projects = res.data.projects;
            this.items = res.data.contributions;

            this.tableLoading = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.tableLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoading = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    approveContribution() {
      this.busy = true;
      this.$http
        .patch(
          this.baseUrl +
            "/manager/contribution/" +
            this.selected.type +
            "/approve/" +
            this.selected.id,
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.PendingDialog = false;
            this.getContributionsData();
            this.busy = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    rejectContribution() {
      this.busy = true;
      this.$http
        .patch(
          this.baseUrl +
            "/manager/contribution/" +
            this.selected.type +
            "/reject/" +
            this.selected.id,
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.PendingRemoveDialog = false;
            this.getContributionsData();
            this.busy = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    doEdit() {
      this.busy = true;
      this.$http
        .patch(
          this.baseUrl +
            "/manager/contribution/" +
            this.selected.type +
            "/edit/" +
            this.selected.id,
          {
            description: this.selected.description,
            repeatCont: this.selected.repeatCont,
            repeatDate: this.selected.repeatDate,
            dateCont: this.selected.dateCont.split(" - ")[1],
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.EditDialog = false;
            this.getContributionsData();
            this.busy = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
  },
  computed: {
    computedCurrentPie() {
      if (this.allPies.length) {
        let pie;
        pie = this.allPies.filter((x) => x.id == this.$route.params.id)[0];
        return pie;
      }
    },
    computedList() {
      let filtered = [];
      if (this.items) {
        filtered = this.items.filter((item) =>
          item.userName.includes(this.filter)
        );
      }

      return filtered;
    },
    computedPendingList() {
      let filtered = [];
      if (this.items.pendingList.list) {
        filtered = this.items.pendingList.list.filter((item) =>
          item.userName.includes(this.filter)
        );
      }
      return filtered;
    },
    computedrejectedList() {
      let filtered = [];
      if (this.items.rejectedList.list) {
        filtered = this.items.rejectedList.list.filter((item) =>
          item.userName.includes(this.filter)
        );
      }
      return filtered;
    },
    computedDeleteList() {
      let filtered = [];
      if (this.items.deleteList.list) {
        filtered = this.items.deleteList.list.filter((item) =>
          item.userName.includes(this.filter)
        );
      }
      return filtered;
    },
  },
  watch: {
    typeFilter(val) {
      this.getContributionsData();
    },
    memberFilter(val) {
      this.getContributionsData();
    },
    projectFilter(val) {
      this.getContributionsData();
    },
    startDate(val) {
      this.getContributionsData();
    },
    tab(val) {
      this.sortBy = "";
      this.filter = "";
    },
  },
  mounted() {
    this.role = localStorage.getItem("role");
    this.getAllPies();
    this.getContributionsData();
  },
};
</script>
